import React from 'react'
import './loaderSpinner.css'

export default function loaderSpinner(){
  return(
    <>
    <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </>
  );
}